import axios from 'src/utils/axios';

export const getArtemisTaskHistory = ({ FisNo }) => {
  return axios.get(`/GetSiriusWorkOrderHistory/${FisNo}`);
};
